const SocialCTA = () => {
  return(
    <div class="relative bg-gray-900">
      <div class="relative h-80 overflow-hidden bg-indigo-600 md:absolute md:left-0 md:h-full md:w-1/3 lg:w-1/2">
        <a href="https://www.instagram.com/drdaryoushdalirii/">
          <img class="h-full w-full object-cover" src="./assets/images/instagram.jpg" alt=""/>
        </a>
      </div>
      <div class="relative mx-auto max-w-7xl py-24 sm:py-32 lg:px-8 lg:py-40">
        <div class="pl-6 pr-6 md:ml-auto md:w-2/3 md:pl-16 lg:w-1/2 lg:pl-24 lg:pr-0 xl:pl-32">
          <h2 class="text-base font-semibold leading-7 text-indigo-400">ما را در شبکه‌های اجتماعی دنبال کنید</h2>
          <p class="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">شبکه های اجتماعی</p>
          <p class="mt-6 text-base leading-7 text-gray-300">
           به اطلاع مراجعه‌کنندگان گرامی می‌رساند که از این پس می‌توانید با دنبال کردن صفحه رسمی ما در اینستاگرام به آدرس sonoscape.iran از جدیدترین اخبار، خدمات و اطلاعات بهره‌مند شوید. همچنین، اگر سوالی دارید، می‌توانید در بخش کامنت پست‌های مرتبط با ما در میان بگذارید تا پاسخگوی شما باشیم. منتظر همراهی شما هستیم!          </p>
          <div class="mt-8">
            <a href="https://www.instagram.com/sonoscape.iran/" class="inline-flex rounded-md bg-white/10 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-white/20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white">اینستاگرام شمیم سلامت پاسارگاد</a>
          </div>
          <div class="mt-8 flex justify-center md:justify-start">
            <a href="https://www.instagram.com/sonoscape.iran/">
              <img src="./assets/images/qr-code.png" width={200}/>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SocialCTA;